import { render, staticRenderFns } from "./MailPopup.vue?vue&type=template&id=d5c42c80"
import script from "./MailPopup.vue?vue&type=script&lang=ts"
export * from "./MailPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports